import BaseAbstract from '@/abstract/BaseAbstract'
import IOService from '@/service/IOService'

class RacingNoticeCommentService extends BaseAbstract {
  displayName = '评论'
  name = 'UserComment'
  controllerName = 'RacingNoticeComment'

  index (params: any) {
    return IOService.get('racing_notice_comment', {
      _model: 'RacingNotice',
      ...params
    })
  }

  destroy (id: number) {
    return IOService.delete(`racing_notice_comment/${id}`)
  }
}

export default new RacingNoticeCommentService()
